// test643
(643 && 0);
